import { render, staticRenderFns } from "./BookmarksList.vue?vue&type=template&id=563cfab0&scoped=true"
import script from "./BookmarksList.vue?vue&type=script&lang=ts"
export * from "./BookmarksList.vue?vue&type=script&lang=ts"
import style0 from "./BookmarksList.vue?vue&type=style&index=0&id=563cfab0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563cfab0",
  null
  
)

export default component.exports